import { h } from "@stencil/core";
import { ComboBoxModel } from "@genexus/chameleon-controls-library/dist/types/components/combo-box/types";
import {
  ModulePropertyData,
  ModuleServerData,
  ModuleVersionData
} from "../types";

export const mapModuleServerDataToComboBoxModel = (
  servers: ModuleServerData[]
): ComboBoxModel =>
  servers.map(server => ({
    value: server.id,
    caption: server.name
  }));

export const mapModuleVersionDataToComboBoxModel = (
  moduleVersions: ModuleVersionData[]
): ComboBoxModel =>
  moduleVersions.map(moduleVersion => ({
    value: moduleVersion.id,
    caption: moduleVersion.name
  }));

export const renderModuleDataProperties = (
  options: Array<ModulePropertyData>
): ModulePropertyData[] => {
  if (options.length) {
    const items: ModulePropertyData[] = [];

    options.forEach(option => {
      const isArray = Array.isArray(option.value);

      if (isArray && option.value.length) {
        const item = (
          <div class="md-property__list-container">
            <p class="md-property__key subtitle-semi-bold-xs">
              {option.name} :
            </p>
            <ul class="md-property__list">
              {(option.value as string[]).map(subItem => {
                return (
                  <li class="md-property__list-item body-regular-s">
                    {subItem}
                  </li>
                );
              })}
            </ul>
          </div>
        );
        items.push(item);
      } else if (!isArray) {
        const item = (
          <div
            class={
              option.inline
                ? "md-property md-property--inline"
                : "md-property md-property--block"
            }
          >
            <p class="md-property__key subtitle-semi-bold-xs">
              {option.name} :
            </p>
            <p class="md-property__value body-regular-s">{option.value}</p>
          </div>
        );
        items.push(item);
      }
    });
    return items;
  }
  return null;
};
